/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  VwbAddGroupMemberRequest,
  VwbGroupListResponse,
  VwbGroupMemberListResponse,
  VwbRemoveGroupMemberRequest,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    VwbAddGroupMemberRequestFromJSON,
    VwbAddGroupMemberRequestToJSON,
    VwbGroupListResponseFromJSON,
    VwbGroupListResponseToJSON,
    VwbGroupMemberListResponseFromJSON,
    VwbGroupMemberListResponseToJSON,
    VwbRemoveGroupMemberRequestFromJSON,
    VwbRemoveGroupMemberRequestToJSON,
} from '../models';

export interface VwbGroupAdminApiAddVwbGroupMemberRequest {
    groupName: string;
    vwbAddGroupMemberRequest: VwbAddGroupMemberRequest;
}

export interface VwbGroupAdminApiListVwbGroupMembersRequest {
    groupName: string;
}

export interface VwbGroupAdminApiRemoveVwbGroupMemberRequest {
    groupName: string;
    vwbRemoveGroupMemberRequest: VwbRemoveGroupMemberRequest;
}

/**
 * 
 */
export class VwbGroupAdminApi extends runtime.BaseAPI {

    /**
     * Adds a user to a VWB group with a specified role. Requires RESEARCHER_DATA_VIEW authority.
     */
    async addVwbGroupMemberRaw(requestParameters: VwbGroupAdminApiAddVwbGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName','Required parameter requestParameters.groupName was null or undefined when calling addVwbGroupMember.');
        }

        if (requestParameters.vwbAddGroupMemberRequest === null || requestParameters.vwbAddGroupMemberRequest === undefined) {
            throw new runtime.RequiredError('vwbAddGroupMemberRequest','Required parameter requestParameters.vwbAddGroupMemberRequest was null or undefined when calling addVwbGroupMember.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/groups/{groupName}/members`.replace(`{${"groupName"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VwbAddGroupMemberRequestToJSON(requestParameters.vwbAddGroupMemberRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a user to a VWB group with a specified role. Requires RESEARCHER_DATA_VIEW authority.
     */
    async addVwbGroupMember(groupName: string, vwbAddGroupMemberRequest: VwbAddGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addVwbGroupMemberRaw({ groupName: groupName, vwbAddGroupMemberRequest: vwbAddGroupMemberRequest }, initOverrides);
    }

    /**
     * Lists all members of a VWB group. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbGroupMembersRaw(requestParameters: VwbGroupAdminApiListVwbGroupMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbGroupMemberListResponse>> {
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName','Required parameter requestParameters.groupName was null or undefined when calling listVwbGroupMembers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/groups/{groupName}/members`.replace(`{${"groupName"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbGroupMemberListResponseFromJSON(jsonValue));
    }

    /**
     * Lists all members of a VWB group. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbGroupMembers(groupName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbGroupMemberListResponse> {
        const response = await this.listVwbGroupMembersRaw({ groupName: groupName }, initOverrides);
        return await response.value();
    }

    /**
     * Lists all groups in the VWB organization. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbGroupListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbGroupListResponseFromJSON(jsonValue));
    }

    /**
     * Lists all groups in the VWB organization. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbGroupListResponse> {
        const response = await this.listVwbGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Removes a user from a VWB group. Requires RESEARCHER_DATA_VIEW authority.
     */
    async removeVwbGroupMemberRaw(requestParameters: VwbGroupAdminApiRemoveVwbGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName','Required parameter requestParameters.groupName was null or undefined when calling removeVwbGroupMember.');
        }

        if (requestParameters.vwbRemoveGroupMemberRequest === null || requestParameters.vwbRemoveGroupMemberRequest === undefined) {
            throw new runtime.RequiredError('vwbRemoveGroupMemberRequest','Required parameter requestParameters.vwbRemoveGroupMemberRequest was null or undefined when calling removeVwbGroupMember.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/groups/{groupName}/members`.replace(`{${"groupName"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: VwbRemoveGroupMemberRequestToJSON(requestParameters.vwbRemoveGroupMemberRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a user from a VWB group. Requires RESEARCHER_DATA_VIEW authority.
     */
    async removeVwbGroupMember(groupName: string, vwbRemoveGroupMemberRequest: VwbRemoveGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeVwbGroupMemberRaw({ groupName: groupName, vwbRemoveGroupMemberRequest: vwbRemoveGroupMemberRequest }, initOverrides);
    }

}
